import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

export const TableBox = props => {
  const {
    children,
    className
  } = props;
  return (
    <div
      className={
        clsx('h-100 w-100', className)}
      style={{ display: 'table' }}>
      {children}
    </div>
  );
};

TableBox.propTypes = {
  className: PropTypes.string
};

export default TableBox;
